export default '6.40.4';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-instantsearch-core/dist/es/core/version.js
// module id = 224
// module chunks = 1